import {initAuthDeps} from '@/di/modules/di.auth-init';
import {initDomainDeps} from '@/di/modules/di.domain-init';
import {initInfraDeps} from '@/di/modules/di.infa-init';

import {Container} from 'brandi';

import {ResourcesAll} from '@/resources';

export function createDiRootContainer(resources: ResourcesAll): Container {
  const container = new Container();

  initInfraDeps(container, resources);
  initAuthDeps(container);
  initDomainDeps(container);

  return container;
}
